import type {
  UserDashboardApiResponseType,
  UserDashboardDataType,
} from '../../types/userDashboardTypes';

const formatCurrency = (amount: number) => new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
}).format(amount);

const formatNumber = (value: number) => new Intl.NumberFormat('en-US').format(value);

export const mapUserDashboardApiToView = (
  api: UserDashboardApiResponseType,
): UserDashboardDataType => ({
  profile: api.profile,
  metrics: [
    {
      id: 'balance',
      label: 'Current Balance',
      value: formatCurrency(api.balance),
      variant: 'green',
    },
    {
      id: 'subscription',
      label: 'Subscription Type',
      value: api.subscriptionType,
      subtext: api.subscriptionInterval ?? undefined,
      variant: 'purple',
    },
    {
      id: 'price',
      label: 'Discount',
      value: api.discount ? api.discount.toString() : '',
      subtext: api.couponCode ? `(${api.couponCode})` : undefined,
      variant: 'blue',
    },
    {
      id: 'revenue',
      label: 'Lifetime Revenue',
      value: formatCurrency(api.lifetimeRevenue),
      variant: 'green',
    },
  ],
  lifetimeRecords: [
    {
      id: 'total',
      label: 'Total Records',
      value: formatNumber(api.lifetimeRecords.totalRecords),
      variant: 'blue',
    },
    {
      id: 'success',
      label: 'Success Records',
      value: formatNumber(api.lifetimeRecords.successRecords),
      variant: 'green',
    },
    {
      id: 'hitRate',
      label: 'Hit Rate',
      value: `${api.lifetimeRecords.hitRate.toFixed(2)}%`,
      variant: 'purple',
    },
  ],
});
